import { Box, Button, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { AppRoute, hasPermission } from '../../../utils/navigation';
import { useUser } from '../../../hooks/useUser';

import { UnpublishedRegistrationList } from './unpublishedRegistrationList';

export const ExpertRegistrationView = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();

  if (!hasPermission(AppRoute.EXPERT_REGISTRATION, user)) {
    return <Navigate to={`${AppRoute.HOME}`} replace />;
  }
  const navigateToNewXml = () => navigate('/ekspertregistrering/xml/enhet/velg-bygg');
  const navigateToNewJson = () => navigate('/ekspertregistrering/json/enhet/velg-bygg');

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography variant="p">{t('energyAssessment.description_fil')}</Typography>
        <Typography variant="h3">{t('energyAssessment.description_jsonfile')}</Typography>
        <ul>
          <li>
            {t("energyAssessment.description_jsonfile.condition1")}
          </li>
        </ul>
        <Box gap={3} display="flex" flexDirection="row">
          <Button onClick={navigateToNewJson} aria-label={t('expertRegistrationScreen.startJsonRegistration')}>
            {t('expertRegistrationScreen.startJsonRegistration')}
          </Button>
        </Box>

        <Typography variant="h3">{t('energyAssessment.description_xmlfile')}</Typography>
        <ul>
          <li>
            {t("energyAssessment.description_xmlfile.condition1")}
          </li>
          <li>
            {t("energyAssessment.description_xmlfile.condition2")}
          </li>
          <li>{t("energyAssessment.description_xmlfile.condition3")}</li>
        </ul>
        <Box gap={3} display="flex" flexDirection="row">
          <Button onClick={navigateToNewXml} aria-label={t('expertRegistrationScreen.startXmlRegistration')}>
            {t('expertRegistrationScreen.startXmlRegistration')}
          </Button>
        </Box>
      </Box>

      <UnpublishedRegistrationList />
    </Fragment>
  );
};
